import React from 'react';
import { NavLink } from 'react-router-dom';
import { Outlet } from 'react-router';
import './assignments.scss';
import AssignmentFloatingMenu from '../../components/AssignmentFloatingMenu';
import AssessmentFloatingMenu from '../../components/AssessmentFloatingMenu';
import ActivitiesFloatingMenu from '../../../activities/ActivitiesFloatingMenu';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const assignmentNav = [
  {
    id: 1,
    name: 'Assignments',
    navigation: '',
    comingSoon: false
  },
  {
    id: 2,
    name: 'Flashcards',
    navigation: 'flashcards',
    comingSoon: false
  },
  {
    id: 3,
    name: 'Assessments',
    navigation: 'assessments',
    comingSoon: false
  }
];

const Index = () => {
  const location = useLocation();

  const nav = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
  const activeItem = assignmentNav.find(item => nav === item.navigation);
  const activeTab = activeItem ? activeItem.id : 1;

  const LayOut = () => {
    return (
      <>
        <div className="white-card assignments-card">
          <h2 className="primary-title">Assignments and Activities</h2>
          <div className="primary-tab">
            <div className="btn-group">
              {assignmentNav.map((item, index) => {
                return (
                  item.comingSoon ? (

                    <OverlayTrigger
                      key={'assignmentTab' + index}
                      placement="top"
                      overlay={<Tooltip className="custom-tooltip">Coming Soon!</Tooltip>}
                    >
                      <NavLink
                        to=""
                        className={({ isActive }) => (isActive ? 'btn' : '')}
                      >
                        {item.name}
                      </NavLink>
                    </OverlayTrigger>
                  ) : (
                    <NavLink
                      key={'assignmentTab' + index}
                      end
                      to={item.navigation}
                      className={({ isActive }) =>
                        `btn rounded fs-15
                          ${isActive ? 'active' : ''}
                          ${item.comingSoon ? 'disabled' : ''}`}
                    >
                      {item.name}
                    </NavLink>
                  )
                );
              }
              )}
            </div>
          </div>
          <Outlet />
        </div>

      </>
    );
  };

  const FloatingMenu = () => {
    return (
      <>
        <div className="floating-menu-space"></div>
        <div className={`floating-menu-contained floating-menu-sticky ${activeTab == 3 ? 'assessment-floating-menu' : ''}`}>
          {
            activeTab == 1
              ? <AssignmentFloatingMenu />
              : activeTab == 2
                ? <ActivitiesFloatingMenu />
                : <AssessmentFloatingMenu />
          }
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <LayOut />
      <FloatingMenu />
    </React.Fragment>
  );
};

export default Index;
